import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertTriangle, CalendarClock, TrendingDown, CheckCircle2 } from "lucide-react";

export default function Alerts() {
  const { data = [], isLoading } = useQuery({
    queryKey: ["alerts"],
    queryFn: () => api.get("/alerts").then((r) => r.data),
    refetchInterval: 30000,
  });

  const danger = data.filter((a) => a.severity === "danger");
  const warning = data.filter((a) => a.severity === "warning");

  const Row = ({ a, i }) => (
    <div
      className="flex items-start gap-3 p-3.5 rounded-lg border"
      style={{ borderColor: a.severity === "danger" ? "#EF444455" : "#F59E0B55", background: a.severity === "danger" ? "#FEF2F2" : "#FFFBEB" }}
      data-testid={`alert-item-${i}`}
    >
      {a.type === "expiry" || a.type === "calibration"
        ? <CalendarClock size={18} style={{ color: a.severity === "danger" ? "#EF4444" : "#F59E0B" }} className="mt-0.5 shrink-0" />
        : <TrendingDown size={18} style={{ color: a.severity === "danger" ? "#EF4444" : "#F59E0B" }} className="mt-0.5 shrink-0" />}
      <div>
        <span className="text-sm text-slate-800">{a.message}</span>
        <div className="text-xs text-slate-400 mt-0.5 capitalize">{a.type} alert · {a.location}</div>
      </div>
    </div>
  );

  return (
    <div className="space-y-5" data-testid="alerts-page">
      <div>
        <h2 className="font-serif text-3xl tracking-tight text-navy">Notification Center</h2>
        <p className="text-slate-500 text-sm mt-1">Live expiry &amp; stock alerts. Auto-refreshing every 30s.</p>
      </div>

      {isLoading && <div className="text-slate-400">Loading alerts…</div>}

      {!isLoading && data.length === 0 && (
        <Card className="p-10 bg-white border-slate-200 text-center" data-testid="no-alerts">
          <CheckCircle2 size={40} className="mx-auto mb-3" style={{ color: "#10B981" }} />
          <div className="font-serif text-xl text-navy">All clear</div>
          <p className="text-slate-500 text-sm mt-1">No active expiry or stock alerts right now.</p>
        </Card>
      )}

      {danger.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle size={18} style={{ color: "#EF4444" }} />
            <h3 className="font-semibold text-slate-700">Critical ({danger.length})</h3>
          </div>
          <div className="space-y-2">{danger.map((a, i) => <Row key={i} a={a} i={i} />)}</div>
        </div>
      )}

      {warning.length > 0 && (
        <div>
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle size={18} style={{ color: "#F59E0B" }} />
            <h3 className="font-semibold text-slate-700">Warnings ({warning.length})</h3>
          </div>
          <div className="space-y-2">{warning.map((a, i) => <Row key={i} a={a} i={i + 100} />)}</div>
        </div>
      )}
    </div>
  );
}
